import { Component, OnInit } from '@angular/core';
import { NzModalRef, NzMessageService } from 'ng-zorro-antd';
import { _HttpClient } from '@delon/theme';
import { ResourceService } from "@ecip/service";

@Component({
  selector: 'app-system-resource-view',
  templateUrl: './view.component.html',
})
export class SystemResourceViewComponent implements OnInit {
  record: any = {};
  i: any;

  constructor(
    private modal: NzModalRef,
    public msgSrv: NzMessageService,
    public resourceService: ResourceService
  ) { }

  ngOnInit(): void {
    this.resourceService.getById(this.record.id).subscribe(res => this.i = res);
  }

  close() {
    this.modal.destroy();
  }
}
